<mat-table [dataSource]="dataSource">

  <ng-container matColumnDef="idCampo">
      <mat-header-cell *matHeaderCellDef> Codice campo </mat-header-cell>
      <mat-cell [attr.data-label]="'idCampo'" *matCellDef="let element"> {{element.idCampo}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="idTpCampoModulo">
      <mat-header-cell *matHeaderCellDef > Tipologia </mat-header-cell>
      <mat-cell [attr.data-label]="'idTpCampoModulo'" *matCellDef="let element">{{showCampiTip(element.idTpCampoModulo)}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="etichetta">
      <mat-header-cell *matHeaderCellDef > Etichetta </mat-header-cell>
      <mat-cell [attr.data-label]="'etichetta'" *matCellDef="let element"> {{element.etichetta}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="descrizione">
      <mat-header-cell *matHeaderCellDef > Descrizione </mat-header-cell>
      <mat-cell [attr.data-label]="'descrizione'" *matCellDef="let element"> {{element.descrizione}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="obbligatorio">
      <mat-header-cell *matHeaderCellDef > Obbligatorio </mat-header-cell>
      <mat-cell [attr.data-label]="'obbligatorio'" *matCellDef="let element">
          <span *ngIf="element.obbligatorio == 'S'">Sì</span>
          <span *ngIf="element.obbligatorio == 'N'">No</span>
      </mat-cell>
  </ng-container>

  <ng-container matColumnDef="predefinito">
    <mat-header-cell *matHeaderCellDef > Natura </mat-header-cell>
    <mat-cell [attr.data-label]="'predefinito'" *matCellDef="let element">
        <span *ngIf="element.predefinito == 'S'">P</span>
        <span *ngIf="element.predefinito == 'N'">C</span>
    </mat-cell>
</ng-container>

  <ng-container matColumnDef="visualizzabile">
      <mat-header-cell *matHeaderCellDef >
          <mat-checkbox *ngIf="!emptyTableMessage" class="example-margin" [checked]="allAbilitati==='S'?true : false" [disabled]="isDettaglio" (change)="setAll($event.checked)"> Visualizzabile </mat-checkbox>
          <p *ngIf="emptyTableMessage" style="margin: 0 0;"> Visualizzabile </p>
      </mat-header-cell>
      <mat-cell [attr.data-label]="'visualizzabile'" *matCellDef="let element">
          <!-- <mat-checkbox
              *ngIf="allAbilitati!=''"
              class="example-margin"
              (change)="sendConf(element)"
              [checked]="(allAbilitati==='S'?true : false) || (templateDistribuito === 'S' && element.flVisibilita === 'S' && element.editatoFE === undefined)"
              [disabled]="isDettaglio|| (templateDistribuito === 'S' && element.flVisibilita === 'S' && element.editatoFE === undefined)"></mat-checkbox> -->
          <mat-checkbox
              class="example-margin"
              (change)="sendConf(element)"
              [checked]="element.flVisibilita == 'S'? true : false"
              [disabled]="isDettaglio || isDisabilitato(element)"></mat-checkbox>
      </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef> {{emptyTableMessage?'':'Azioni'}} </mat-header-cell>
      <mat-cell *matCellDef="let element">
          <span *ngIf="element.idCampo !== openToggle" class="material-icons" title="apri/chiudi toolbar"
            (click)="openToggle = element.idCampo">more_horiz</span>
          <myp-toolbar *ngIf="element.idCampo === openToggle" [toolbar]="generateToolBar(element)" role=toolbar [data]="element" (onToolbarEvent)="handleToolbarEvent($event)" [persCSSClassDiv]="element.idCampo === openToggle?'no-rad':''">
          </myp-toolbar>
          <myp-toolbar *ngIf="checkIfElementCanMove(element)" [toolbar]="orderToolbar" role=toolbar [data]="element" (onToolbarEvent)="handleToolbarEvent($event)" [ngClass]="{'space-toolbar': element.idCampo !== openToggle}" [persCSSClassDiv]="element.idCampo === openToggle?'no-rad':''">
          </myp-toolbar>
      </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let element ; columns: displayedColumns;" [ngClass]="{'grey':isCampoDgpe(element)}" ></mat-row>s

</mat-table>

<div *ngIf="emptyTableMessage">
  <mat-card class="emptyTable">
      <mat-card-content>
          <h6 *ngIf="tpm !== 4">
              Non ci sono risultati
          </h6>

          <div class="flex-row right" *ngIf="tpm === 4">
            <!-- <mat-form-field appearance="legacy" color='accent' class="span-span">
              <input hidden matInput>
            </mat-form-field>
            <mat-form-field appearance="legacy" color='accent' class="span-span">
              <input hidden matInput>
            </mat-form-field> -->
                <myp-toolbar [toolbar]="menuAddLibero" role=toolbar (onToolbarEvent)="handleToolbarEvent($event)">
                </myp-toolbar>
          </div>
      </mat-card-content>
  </mat-card>
</div>

<mat-paginator id='paginator' [pageSize]="risultatiPerPagina" [pageSizeOptions]="[3, 5, 10, 100]"></mat-paginator>

<!-- <hr>
<div class="flex-row" [hidden]="isDettaglio">
  <div class="flex-display">
      <button (click)="openDettaglioCampoDialog('','')" mat-button class="pers">
          <mat-icon>add</mat-icon>
      </button>
      <span style="margin-bottom: 5px; margin-left: 5px;">Aggiungi campo</span>
  </div>
</div> -->
